export const smartphone = 'LS';
export const television = 'LT';

export default {
  smartphone,
  television,
};
